import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'tasksTitle',
  standalone: false
})
export class TasksTitlePipe implements PipeTransform {

  transform(type?: string): string {

    if (!type) {
      return 'TASKS.TITLE';
    }

    switch (type) {
      case 'checklist':
        return 'TASKS.CHECKLISTS_TITLE';

      case 'audit':
        return 'TASKS.AUDITS_TITLE';

      case 'appcc':
        return 'TASKS.APPCC_TITLE';

      default:
        return 'TASKS.TITLE';
    }

  }

}
